<template>
    <div class="list-group no-border border-radius-2 mb-4">
        <div class="list-group-item d-flex flex-row align-items-center">
            <div class="text-sm font-weight-bold mr-auto">{{ $t('teachers') }}</div>
            <button class="btn btn-secondary btn-sm" @click="addTeacher"><b-icon icon="plus" /> {{ $t('add') }}</button>
        </div>
        <div class="list-group-item" v-for="(user, uindex) in innerValue" :key="uindex">
            <template v-if="user.substitute">
                {{$t('{s}-substituting-for-{t}' , {'s': user.substitute.displayname , 't': user.displayname})}}
                <button class="btn btn-secondary btn-sm" @click="removeSubstitute(user)">{{ $t('remove') }}</button>
            </template>
            <template v-else-if="user.absent">
                {{$t('{s}-absent', {'s': user.displayname}) }}
            </template>
            <template v-else>
                {{user.displayname}}
            </template>

            <div v-if="user.on_rota" class="float-right">
                <template v-if="!user.substitute">
                    <button v-if="!user.absent" class="btn btn-secondary btn-sm mr-2" @click="addSubstitute(user)">{{ $t('substitute') }}</button>
                    <button class="btn btn-secondary btn-sm" @click="toggleAbsent(user)">{{ user.absent ? $t('mark-present') : $t('mark-absent') }}</button>
                </template>
            </div>
            <button class="btn btn-danger btn-sm float-right" v-else @click="removeTeacher(user.id)">{{ $t('remove') }}</button>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
    },
    mounted() {
        this.getTeachers()
    },
    data() {
        return {
            innerValue: this.value,
            teachers: [],
        }
    },
    methods: {
        getTeachers() {
            return this.$users.getTeachers.call(this).then(teachers => {
				this.teachers = teachers

                const teachersById = this.teachers.reduce((prev, curr) => {
                    prev[curr.id] = curr
                    return prev
                }, {})

                this.innerValue = this.innerValue.map(teacher => {
                    const details = teachersById[teacher.id]
                    teacher.displayname = details.displayName
                    
                    if (!teacher.substitute_id) return teacher

                    const subDetails = teachersById[teacher.substitute_id]
                    teacher.substitute = {
                        id: teacher.substitute_id,
                        displayname: subDetails.displayName,
                    }
                    
                    return teacher
                })
			});
        },
        addTeacher() {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("teacher"),
				selectCallback: function(selection) {
					self.innerValue.push({
						'id': selection.id,
						'displayname': selection.displayName,
						'on_rota': false,
                        'absent': false,
					})
					self.$store.commit("closeModal");
				},
				selected: [],
				data: this.teachers,
				captionKey: "displayName"
			});
		},
		removeTeacher(id) {
			this.innerValue = this.innerValue.filter(teacher => teacher.id !== id)
		},
		addSubstitute(user) {
			const self = this
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("teacher"),
				selectCallback(selection) {
                    self.$set(user, 'substitute_id', selection.id)
					self.$set(user, 'substitute', {
						id: selection.id,
						displayname: selection.displayName,
					});
                    self.$store.commit("closeModal");
                    self.$forceUpdate()
				},
				selected: [],
				data: this.teachers.filter(teacher => !self.innerValue[teacher.id]),
				captionKey: "displayName"
			});
		},
		removeSubstitute(user) {
			this.$set(user, 'substitute', undefined)
			this.$set(user, 'substitute_id', undefined)
            this.$forceUpdate()
		},
		toggleAbsent(user) {
			this.$set(user, 'substitute', undefined)
			this.$set(user, 'absent', !user.absent)
		},
    },
    watch: {
        innerValue: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal)
            },
        }
    },
}
</script>